import { useState } from "react";
import { doc, writeBatch } from "firebase/firestore"; // Import writeBatch
import { db } from "../firebase"; // Import your Firestore instance

const useDeleteProducts = () => {
  const [isPending, setIsPending] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  /**
   * Deletes multiple products from a specific list in Firestore using a batch write.
   * @param {string} listId The ID of the list the products belong to.
   * @param {string[]} productIds An array of IDs of the products to delete.
   */
  const deleteProducts = async (listId, productIds) => {
    setIsPending(true);
    setIsError(false);
    setIsSuccess(false);

    try {
      if (!listId) {
        throw new Error("listId is required to delete products.");
      }
      if (!Array.isArray(productIds) || productIds.length === 0) {
        throw new Error(
          "An array of productIds is required to delete products."
        );
      }

      const batch = writeBatch(db); // Get a new write batch

      productIds.forEach((productId) => {
        const productRef = doc(db, "lists", listId, "products", productId);
        batch.delete(productRef); // Add each delete operation to the batch
      });

      await batch.commit(); // Commit the batch

      setIsSuccess(true);
      console.log(
        `${productIds.length} products deleted successfully from list ${listId}.`
      );
    } catch (error) {
      setIsError(true);
      console.error("Error deleting products:", error);
      throw error; // Re-throw to allow component to catch if needed
    } finally {
      setIsPending(false);
    }
  };

  const resetStatus = () => {
    setIsPending(false);
    setIsError(false);
    setIsSuccess(false);
  };

  return { deleteProducts, isPending, isError, isSuccess, resetStatus };
};

export default useDeleteProducts;
